

import state from './moduleStatistiquesState.js'
import mutations from './moduleStatistiquesMutations.js'
import actions from './moduleStatistiquesActions.js'
import getters from './moduleStatistiquesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

